import { render, staticRenderFns } from "./ExpertUploadView.vue?vue&type=template&id=2a87ee96&scoped=true"
import script from "./ExpertUploadView.vue?vue&type=script&lang=js"
export * from "./ExpertUploadView.vue?vue&type=script&lang=js"
import style0 from "./ExpertUploadView.vue?vue&type=style&index=0&id=2a87ee96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87ee96",
  null
  
)

export default component.exports